import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

import imgTouchposeMenu from '../../../assets/images/docs/touchpose-maya-menu.png';
import { Body, MenuPath } from '../ui';

const MayaMenuDoc: React.FC = () => {
  const { t } = useTranslation();

  return (
    <article className="font-body text-content-primary">
      <h2 className="font-display text-[24px] font-extrabold text-content-primary mb-[24px] tracking-[-0.4px]">
        {t('docs.mayaMenu.title')}
      </h2>

      <div className="mb-[32px]">
        <img
          src={imgTouchposeMenu}
          alt={t('docs.mayaMenu.imgAlt')}
          className="block max-w-full w-auto rounded-[10px] border border-surface-hover shadow-[0_2px_12px_rgba(34,211,238,0.08),0_1px_4px_rgba(0,0,0,0.06)]"
        />
      </div>

      <Body>
        <Trans
          i18nKey="docs.mayaMenu.enabled"
          components={{ strong: <strong />, br: <br /> }}
        />
      </Body>
      <Body>
        <Trans
          i18nKey="docs.mayaMenu.updateAvailable"
          components={{ strong: <strong />, br: <br /> }}
        />
      </Body>
      <Body>
        <Trans
          i18nKey="docs.mayaMenu.touchSetEditor"
          components={{ strong: <strong />, br: <br /> }}
        />
      </Body>
      <Body>
        <Trans
          i18nKey="docs.mayaMenu.drawPose"
          components={{
            strong: <strong />,
            br: <br />,
            code: <MenuPath>{''}</MenuPath>
          }}
        />
      </Body>
      <Body>
        <Trans
          i18nKey="docs.mayaMenu.licenseActivation"
          components={{ strong: <strong />, br: <br /> }}
        />
      </Body>
      <Body>
        <Trans
          i18nKey="docs.mayaMenu.preferences"
          components={{ strong: <strong />, br: <br /> }}
        />
      </Body>
      <Body>
        <Trans
          i18nKey="docs.mayaMenu.enableTouchNodes"
          components={{ strong: <strong />, br: <br /> }}
        />
      </Body>
      <Body>
        <Trans
          i18nKey="docs.mayaMenu.selectTouchNodes"
          components={{ strong: <strong />, br: <br /> }}
        />
      </Body>
      <Body>
        <Trans
          i18nKey="docs.mayaMenu.touchPoseHome"
          components={{ strong: <strong />, br: <br /> }}
        />
      </Body>
      <Body>
        <Trans
          i18nKey="docs.mayaMenu.documentation"
          components={{ strong: <strong />, br: <br /> }}
        />
      </Body>
      <Body>
        <Trans
          i18nKey="docs.mayaMenu.changelog"
          components={{ strong: <strong />, br: <br /> }}
        />
      </Body>
      <Body>
        <Trans
          i18nKey="docs.mayaMenu.about"
          components={{ strong: <strong />, br: <br /> }}
        />
      </Body>
    </article>
  );
};

export default MayaMenuDoc;
